<template>
  <div class="te-header ">
    <!-- 預留給以後麵包屑的位置div要留著 begin -->
    <div />
    <!-- 預留給以後麵包屑的位置div要留著 end -->
    <div class="d-flex justify-content-end align-items-center mr-3">
      <b-form-select
        v-model="selectCompany"
        size="sm"
        class="mr-3 border-0"
        :options="companiesOption"
      />
      <a
        id="HeaderSetting"
        href="#"
        class="image-panel image-panel-n1 mr-1 rounded-pill"
      >
        <template>
          <img v-if="user.avatar" :src="user.avatar" @error="onAvatarLoadingError">
          <img v-else src="@/assets/images/default-avatar.png">
        </template>
        <img>
      </a>
      <b-popover
        target="HeaderSetting"
        triggers="focus"
        placement="bottomleft"
        custom-class="header-setting-popover mt-2"
        :show.sync="accountPopoverShow"
      >
        <div class="font-size-md">
          <b-list-group class="py-2">
            <b-list-group-item
              href="#"
              class="border-0 py-2"
              @click="editProfile"
            >
              {{ $t('frame.accountManage') }}
            </b-list-group-item>
            <b-list-group-item
              href="#"
              class="border-0 py-2"
              @click="logout"
            >
              {{ $t('frame.logout') }}
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-popover>
    </div>
    <AccountSetting v-if="accountSettingShow" :user-id="user.id" @close="closeAccountSetting" @confirm="accountSaved" />
  </div>
</template>

<script>
import defaultAvatar from '@/assets/images/default-avatar.png';
import AccountSetting from '@/components/Account/AccountSetting';
import * as AuthorizationService from '@/services/AuthorizationService';
import PermissionService from '@/services/PermissionService';

export default {
  components: {
    AccountSetting
  },
  data() {
    return {
      companies: [],
      user: {},
      accountPopoverShow: false,
      accountSettingShow: false,
      alertShow: false,
      alertOptions: {}
    };
  },
  computed: {
    userId() {
      return this.$store.getters.userId;
    },
    companiesOption() {
      return this.companies.map((item) => ({ value: item.id, text: item.name }));
    },
    selectCompany: {
      get() {
        return this.$store.getters.company;
      },
      set(val) {
        this.$store.commit('setCompany', val);
      }
    }
  },
  watch: {
    userId() {
      this.LoadUserAsync();
    },
    selectCompany() {
      this.$router.push({
        path: '/',
        query: {
          t: +new Date()
        }
      });
    }
  },
  created() {
    this.$store.dispatch('loadCompany');
    this.LoadUserAsync();
    this.LoadCompaniesAsync();
  },
  methods: {
    async LoadCompaniesAsync() {
      await this.$loading(async () => {
        const companies = await AuthorizationService.GetCompaniesAsync();
        if (companies.length > 0) {
          if ((this.selectCompany || '') === '' || companies.filter((item) => item.id === this.selectCompany)[0] === undefined) {
            this.selectCompany = companies[0].id;
          }
        }
        this.companies = companies;
      });
    },
    async LoadUserAsync() {
      await this.$loading(async () => {
        this.user = await PermissionService.GetLoginUserProfileAsync();
      });
    },
    editProfile() {
      this.accountPopoverShow = false;
      this.accountSettingShow = true;
    },
    async accountSaved() {
      this.$notify.saveSuccess();
      this.accountSettingShow = false;
      this.user = await PermissionService.GetLoginUserProfileAsync();
    },
    onAvatarLoadingError(e) {
      e.target.src = defaultAvatar;
    },
    showAlert(options) {
      this.alertOptions = options;
      this.alertShow = true;
    },
    closeAccountSetting() {
      this.accountSettingShow = false;
    },
    logout() {
      this.$router.push({ path: '/Logout' });
    }
  }
};
</script>
